import React from "react";
import { AddressComponents } from "../../messages/Visit";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { LOCATION_ICON } from "../../utils/svgs_new";
import { MapWithLocations } from "../MapWithLocations";
import { AppButton } from "./AppButton";
import { AppIcon } from "./AppIcon";
import { AppAbstractModal } from "./AppModal/AppAbstractModal";
import Flex from "./Flex";

export interface AppLocationModalProps {
  isOpen: boolean;
  originLocation: google.maps.LatLngLiteral;
  destination: AddressComponents;
  destinationText: string | null;
  onClickDirections: () => void;
  onRequestClose: () => void;
}

export const AppLocationModal = (props: AppLocationModalProps) => {
  const renderedDestinationText = React.useMemo(() => {
    const destinationText = props.destinationText;
    if (destinationText === null) {
      return null;
    }
    const commaIndex = destinationText.indexOf(",");
    let line1 = "";
    let line2 = "";
    if (commaIndex === -1) {
      line1 = destinationText;
    } else {
      line1 = destinationText.slice(0, commaIndex);
      line2 = destinationText.slice(commaIndex + 1, destinationText.length);
    }

    return (
      <div className="destination">
        <span>{line1}</span>
        <span>{line2}</span>
      </div>
    );
  }, [props.destinationText]);

  // Used useEffect due to map rendering interuppting modal popup animation
  const [showMap, setShowMap] = React.useState(false);

  React.useEffect(() => {
    if (!props.isOpen) {
      return;
    }

    const timeout = setTimeout(() => setShowMap(true), 500);

    return () => clearTimeout(timeout);
  }, [props.isOpen]);

  const map = React.useMemo(() => {
    if (showMap) {
      return <MapWithLocations location={[props.destination.location]} zoom={20} />;
    }

    return null;
  }, [props.destination.location, showMap]);

  return (
    <AppAbstractModal
      isOpen={props.isOpen}
      className="AppLocationModal"
      onRequestClose={props.onRequestClose}
    >
      <div className="header">{map}</div>
      <div className="content">
        <Flex direction="column" yGap={24}>
          {renderedDestinationText}
          <Flex direction="column">
            <AppButton variant="soft" color="primary" onClick={props.onClickDirections}>
              <Flex direction="row" alignItems="center">
                <AppIcon icon={LOCATION_ICON} size={20} style={{ marginRight: 10 }} />
                {translate(STRINGS.DIRECTIONS)}
              </Flex>
            </AppButton>
            <AppButton variant="link" color="black" onClick={props.onRequestClose}>
              {translate(STRINGS.CLOSE)}
            </AppButton>
          </Flex>
        </Flex>
      </div>
    </AppAbstractModal>
  );
};
